import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import SendToMessenger from '../../../../../common/components/facebook-plugin-components/SendToMessenger/SendToMessenger';
import { HandlerMethodTypes, StateUpdaterMethodTypes } from '@mm/utils';
import PageModel from '@mm/state/model/PageModel';
import { getFbPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import './MessengerPluginBlock.scss';

type OuterProps = {
  selectedPage: PageModel;
  buttonText?: string;
  size?: 'large' | 'xlarge';
};
type StoreProps = ReturnType<typeof mapStateToProps>;
type ExternalProps = OuterProps & StoreProps;

type InitialState = ReturnType<typeof initialState>;
type StateUpdaters = StateUpdaterMethodTypes<
  InitialState,
  ExternalProps,
  typeof stateUpdaters
>;

type HandlerProps = ExternalProps & InitialState & StateUpdaters;
type HandlerMethods = HandlerMethodTypes<HandlerProps, typeof handlers>;

type InnerProps = InitialState & StateUpdaters & HandlerMethods;

type Props = InnerProps & ExternalProps;

const mapStateToProps = (state: StoreState, props: OuterProps) => ({
  fbPageId: getFbPageIdSelector(state),
  fbAppId: state.env.fbAppId,
});
const initialState = (props: ExternalProps) => ({
  showFacebookPlugin: true,
});
const stateUpdaters = {
  setShowFacebookPlugin: () => (showFacebookPlugin: boolean) => ({
    showFacebookPlugin,
  }),
};

const onOpenClick =
  ({ setShowFacebookPlugin, fbPageId }: HandlerProps) =>
  () => {
    window.open(`http://m.me/${fbPageId}`);
    setTimeout(() => setShowFacebookPlugin(true), 1000);
  };
const handlers = {
  onOpenClick,
};

const MessengerPluginBlock = (props: Props) => {
  const {
    fbAppId,
    fbPageId,
    selectedPage,
    showFacebookPlugin,
    setShowFacebookPlugin,
    onOpenClick,
    buttonText,
  } = props;
  if (!(fbAppId && selectedPage)) return null;
  const size = props.size || 'xlarge';

  return (
    <div className={`messenger-plugin-block messenger-plugin-block-${size}`}>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .messenger-plugin-block .fb-send-to-messenger.fb_iframe_widget::before {
            content: "${buttonText || 'Send a test to me'}";
          }
        `,
        }}
      />
      {showFacebookPlugin ? (
        <SendToMessenger
          appId={fbAppId}
          pageId={fbPageId}
          passthroughParams={selectedPage.searchToken}
          onClick={() => setShowFacebookPlugin(false)}
          size={size}
        />
      ) : (
        <div
          className="test-bot-button__open-messenger-button"
          onClick={onOpenClick}
        >
          Open Messenger
        </div>
      )}
    </div>
  );
};

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps),
  withStateHandlers(initialState, stateUpdaters),
  withHandlers(handlers),
);

export default enhance(MessengerPluginBlock);
